import { useTranslation } from "react-i18next";
import { SelectField } from "@/shared/ui/core";
import { TextAreaField } from "@/features/admin/components";
import { EditorialBlock, type EditorialBlockLocaleProps } from "./EditorialBlock";
import { useBlockFilled } from "./useBlockFilled";
import { useClosingThemeOptions } from "../../productOptions";

/**
 * Bloque 11 · El cierre: la frase con la que termina la ficha.
 *
 * Es lo último que se lee antes de decidir, y por eso tiene su propio
 * bloque en vez de ser un párrafo más de la descripción.
 */
export function EditorialClosingBlock({ locale }: EditorialBlockLocaleProps) {
  const { t } = useTranslation();
  const name = `editorial.${locale}.closing`;
  const filled = useBlockFilled(name);
  const themeOptions = useClosingThemeOptions();

  return (
    <EditorialBlock
      name={name}
      title={t("Cierre")}
      description={t("La frase final de la ficha.")}
      filled={filled}
    >
      <TextAreaField
        name={`${name}.quote`}
        label={t("Frase")}
        rows={3}
        fieldClassName="sm:col-span-2"
      />
      <SelectField
        name={`${name}.theme`}
        label={t("Tema")}
        options={themeOptions}
        placeholder={t("El de la ficha")}
      />
    </EditorialBlock>
  );
}
